import {MESSAGE_TYPE} from '../../CodeMaster'

export class RequestError {
    messageId: string
    title: string
    message: string
    type: MESSAGE_TYPE


    constructor(messageId: string, title: string, message: string, type: MESSAGE_TYPE) {
        this.messageId = messageId
        this.title = title
        this.message = message
        this.type = type
    }

    static from(json: any): RequestError {
        return new RequestError(
            json.requestError.messageId,
            json.requestError.title || '',
            json.requestError.message,
            MESSAGE_TYPE.codeToEnumConstants(json.requestError.type),
        )
    }
}
